<template>
  <transition @enter="enter" @beforeLeave="leave">
    <div class="__popup" :id="id" v-if="checkId" ref="popup">
      <div class="__container" ref="popupWrap" :class="`__${size}`">
        <div class="__header">
          <div>
            <slot name="title"></slot>
          </div>
          <div v-if="id!=='chon-chi-nhanh'">
            <slot name="iconClose">
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="cursor: pointer"
                @click="hidePopup(id)"
              >
                <rect width="36" height="36" rx="18" fill="#F0F0F0" />
                <path
                  d="M11.1885 23.0509C10.8193 23.4201 10.8018 24.0792 11.1973 24.466C11.584 24.8527 12.2432 24.8439 12.6123 24.4747L17.9912 19.087L23.3789 24.4747C23.7568 24.8527 24.4072 24.8527 24.794 24.466C25.1719 24.0704 25.1807 23.4288 24.794 23.0509L19.415 17.6632L24.794 12.2843C25.1807 11.9064 25.1807 11.256 24.794 10.8693C24.3984 10.4913 23.7568 10.4826 23.3789 10.8605L17.9912 16.2482L12.6123 10.8605C12.2432 10.4913 11.5752 10.4738 11.1973 10.8693C10.8106 11.256 10.8193 11.9152 11.1885 12.2843L16.5762 17.6632L11.1885 23.0509Z"
                  fill="#808890"
                />
              </svg>
            </slot>
          </div>
        </div>

        <slot name="message"></slot>

        <div class="__content">
          <slot name="content"></slot>
        </div>

        <div class="__controls">
          <div>
            <slot name="control-left"></slot>
          </div>
          <div>
            <slot name="control-right"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      checkId: false,
    };
  },

  props: {
    id: {
      type: String,
      default: "",
    },

    size: {
      type: String,
      default: "",
    },
  },

  computed: {
    ...mapGetters("popup", ["getActivePopup"]),
  },

  methods: {
    enter() {
      this.gsap.fromTo(this.$refs.popup, { opacity: 0 }, { opacity: 1 });
      this.checkId = true;
    },

    leave() {
      this.gsap.to(this.$refs.popup, { opacity: 0 });
      this.checkId = false;
    },
  },

  watch: {
    getActivePopup: {
      handler: function () {
        if (this.getActivePopup === this.id) {
          this.enter();
        } else if (this.getActivePopup != this.id) {
          this.leave();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.__popup {
  position: fixed;
  inset: 0;
  height: 100%;
  width: 100%;

  background: #0004;

  padding: 80px 16px;

  display: flex;
  flex-flow: column;
  align-content: center;
  justify-content: center;

  z-index: 20;

  .__container {
    margin: auto;
    width: 100%;
    max-width: 600px;
    height: auto;
    background: #ffffff;

    box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08),
      0px 8px 12px -8px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    .__header {
      flex: 0 0 auto;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      padding: 12px 20px;
      color: #000;
      display: flex;
      align-items: center;
      justify-content: space-between;

      background: #f1f2f4;
      z-index: 9999999;
    }

    .__controls {
      padding: 10px 20px;
      display: flex;
      align-content: space-between;
      justify-content: space-between;
      border-top: 1px solid #dddddd;

      > * {
        display: flex;
        gap: 8px;
      }
    }

    .__content {
      flex: 0 1 auto;
      padding: 20px;

      overflow: auto;
    }
  }
}

.__small {
  max-width: 480px !important;
}
</style>
